import type { PlanSource } from "@atlas/shared";

// Shared labels and formatters for the subscription surfaces (spec 24).

export const SOURCE_LABEL: Record<PlanSource | string, string> = {
  none: "Free",
  stripe: "Stripe",
  apple: "App Store",
  google: "Google Play",
  key: "Plan key",
  invite: "Beta invite",
  admin: "Complimentary",
  supporters: "Supporter",
};

export const PROVIDER_COLOR: Record<string, string> = {
  stripe: "var(--sky-500)",
  apple: "var(--text-secondary)",
  google: "var(--spruce-500)",
  key: "var(--accent)",
  invite: "var(--gold-300, var(--accent))",
  admin: "var(--text-muted)",
  supporters: "var(--accent)",
};

export const KIND_LABEL: Record<string, string> = {
  activated: "Activated",
  activated_invoice: "First invoice paid",
  renewed: "Renewed",
  payment: "Payment",
  payment_failed: "Payment failed",
  grace: "Grace period",
  cancel_scheduled: "Cancel scheduled",
  cancelled: "Cancelled",
  lapsed: "Lapsed",
  refunded: "Refunded",
  order_paid: "Store order paid",
  order_expired: "Store checkout expired",
  order_refunded: "Store order refunded",
  admin_grant: "Complimentary Pro granted",
  admin_extend: "Extended",
  admin_revoke: "Revoked",
  key_redeemed: "Plan key redeemed",
  invite_claimed: "Beta seat claimed",
  conflict_cleared: "Store id cleared",
  full_history_granted: "Full history granted",
  full_history_revoked: "Full history revoked",
  full_history_checkout: "Full history checkout",
  disputed: "Disputed",
  updated: "Updated",
};

export function kindLabel(kind: string): string {
  return KIND_LABEL[kind] ?? kind.replace(/_/g, " ");
}

export function sourceLabel(source: string | null | undefined): string {
  return SOURCE_LABEL[source ?? "none"] ?? source ?? "Free";
}

export function formatPence(pence: number | null | undefined, currency = "gbp"): string {
  if (pence == null) return "—";
  const symbol = currency.toLowerCase() === "gbp" ? "£" : currency.toLowerCase() === "eur" ? "€" : currency.toLowerCase() === "usd" ? "$" : `${currency.toUpperCase()} `;
  return `${symbol}${(pence / 100).toFixed(2)}`;
}

export function formatDay(value: string | null | undefined): string {
  if (!value) return "—";
  const d = new Date(value);
  if (!Number.isFinite(d.getTime())) return "—";
  return d.toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" });
}

export function formatMonth(value: string): string {
  const d = new Date(value);
  return d.toLocaleDateString("en-GB", { month: "short", year: "2-digit" });
}
